<template>
  <div class="icp-container">
    <span>
      {{ `© ${new Date().getFullYear()}` }}
      <a href="https://www.carrier.com/" target="_blank" style="color: #fff; text-decoration: underline">Carrier</a>
      {{ i18n.label.AllRightsReserved }}
    </span>
    <span>{{ `${name} ${version}` }}</span>
  </div>
</template>
<script>
const { serviceConfig } = require("@/config/index") // config/index module been set as a CommonJS module, so need to import it according to the CommonJS.
export default {
  data() {
    return {
      version: serviceConfig.version,
      name: serviceConfig.name
    }
  },
  computed: {
    i18n() {
      return this.$t("index")
    }
  },
  methods: {}
}
</script>

<style scoped>
.icp-container {
  text-align: center;
  bottom: 0;
  width: 100%;
  font-size: 12px;
  padding: 2px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/desktop/VerInfo.vue